<template>
  <div class="comps-cardg-item" @click="$emit('click')">
    <div class="back-content">
      <h3 class="to-2" v-html="title"></h3>
      <p class="to-2 silver" v-html="info"></p>
      <p class="to-2 silver">Author: {{author}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    info: {
      type: String,
      default: ''
    },
    author: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="less" scoped>
  @import url('../../../utils/color.less');
  .comps-cardg-item {
    width: 100%;
    position: relative;
    .back-content {
      h3 {
        margin: 0 0 10px;
      }
      p {
        margin: 20px 0 0;
      }
    }
  }
  .comps-cardg-item:hover {
    cursor: pointer;
    .back-content {
      h3 {
        color: @primary;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Models/comps/cardCasesB.vue